// src/data/nobishiro-9-questions.js

// NOBISHIRO 9項目の能力定義
export const nobishiroAbilities = {
    N: { name: "粘り強さ", description: "困難な状況でも諦めずに続ける力" },
    O: { name: "思考力", description: "物事を多角的に分析し考える力" },
    B: { name: "バランス力", description: "対立する要素の均衡を取る力" },
    I: { name: "イノベーション力", description: "新しいアイデアを生み出す力" },
    S: { name: "共感力", description: "他者の感情や立場を理解する力" },
    H: { name: "協働力", description: "多様な人々と協力して成果を出す力" },
    I2: { name: "主体性", description: "自分から行動を起こす力" },
    R: { name: "振り返り力", description: "経験から学び成長する力" },
    O2: { name: "最適化力", description: "効率的な方法を見つける力" }
};

// 上記9能力を測定するための全27問 (旧108問から厳選)
export const nobishiroQuestions = [
  // N: 粘り強さ
  { id: 'N1', text: "新しい趣味や習い事の初心者段階でつまずいても、工夫しながら続けられる。", category: 'N', isReversed: false },
  { id: 'N2', text: "難しいレシピの料理が失敗しても、何度も挑戦して完成させることができる。", category: 'N', isReversed: false },
  { id: 'N3', text: "長期的な目標のために短期的な困難を乗り越えるのは苦手だ。", category: 'N', isReversed: true },
  // O: 思考力
  { id: 'O1', text: "人間関係のトラブルを、個人の性格のせいにせず状況や関係性から分析できる。", category: 'O', isReversed: false },
  { id: 'O2', text: "家電が頻繁に故障する場合、使い方や環境など根本原因を探ることができる。", category: 'O', isReversed: false },
  { id: 'O3', text: "インターネットやSNSの情報が本当に信頼できるか、批判的に考えられる。", category: 'O', isReversed: false },
  // B: バランス力
  { id: 'B1', text: "家族旅行の計画で、大人の希望と子どもの希望をバランスよく取り入れられる。", category: 'B', isReversed: false },
  { id: 'B2', text: "当面の生活費と将来のための貯蓄のバランスを考えて家計管理できる。", category: 'B', isReversed: false },
  { id: 'B3', text: "会話で、話す時間と聞く時間のバランスを意識している。", category: 'B', isReversed: false },
  // I: イノベーション力
  { id: 'I1', text: "マンネリ化した日常に、小さな変化や新しい要素を取り入れられる。", category: 'I', isReversed: false },
  { id: 'I2', text: "使いづらい家電や道具を見て、改良すべき点や新機能のアイデアを思いつく。", category: 'I', isReversed: false },
  { id: 'I3', text: "別の角度から考えるより、いつもの方法で物事を進める方が安心する。", category: 'I', isReversed: true },
  // S: 共感力
  { id: 'S1', text: "友人や家族の表情や声のトーンから、言葉にされていない感情に気づける。", category: 'S', isReversed: false },
  { id: 'S2', text: "自分とは全く異なる世代や環境で育った人の視点から物事を考えられる。", category: 'S', isReversed: false },
  { id: 'S3', text: "友人との約束を忘れることが多く、スケジュール管理が苦手だ。", category: 'S', isReversed: true },
  // H: 協働力
  { id: 'H1', text: "料理上手な人、片付け上手な人など、それぞれの得意を活かして家事を分担できる。", category: 'H', isReversed: false },
  { id: 'H2', text: "性格や好みが全く異なる人とも、楽しく交流することができる。", category: 'H', isReversed: false },
  { id: 'H3', text: "チームで活動するより、一人で取り組む方が好きだ。", category: 'H', isReversed: true },
  // I2: 主体性
  { id: 'I2-1', text: "周囲が消極的でも、良いと思ったレジャーや活動を自分から提案する。", category: 'I2', isReversed: false },
  { id: 'I2-2', text: "進路や生活の選択で、周囲の評価より自分が本当にしたいことを優先できる。", category: 'I2', isReversed: false },
  { id: 'I2-3', "text": "自分の人生目標を自分で設定し、それに向けた計画を立てて行動できる。", category: 'I2', isReversed: false },
  // R: 振り返り力
  { id: 'R1', text: "定期的に自分の目標に対する進捗状況を確認する習慣がある。", category: 'R', isReversed: false },
  { id: 'R2', text: "日記をつけるなど、日々の出来事や感情を定期的に振り返る習慣がある。", category: 'R', isReversed: false },
  { id: 'R3', text: "自分の行動や発言への批判を、攻撃ではなく学びの機会として受け止められる。", category: 'R', isReversed: false },
  // O2: 最適化力
  { id: 'O2-1', text: "同じ結果を得るために、より少ない手間や時間で済む方法を考えられる。", category: 'O2', isReversed: false },
  { id: 'O2-2', text: "毎日の家事や身支度の手順を見直し、より効率的な方法を見つけられる。", category: 'O2', isReversed: false },
  { id: 'O2-3', text: "よく考えずに行動してしまい、後から反省することが多い。", category: 'O2', isReversed: true },
];
